var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBpcSlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 106.58761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 577.75527,
    y1: 1920.51712,
    x2: 628.95885,
    y2: 1920.51712,
    gradientTransform: "translate(938.42535 -1769.21875) rotate(44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a8d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26937,
    stopColor: "#2086c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56635,
    stopColor: "#3e68ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82045,
    stopColor: "#50559e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#574f9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 572.51272,
    y1: 1926.44013,
    x2: 634.76587,
    y2: 1926.44013,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 571.69227,
    y1: 1927.37444,
    x2: 635.44849,
    y2: 1927.37444,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 576.45296,
    y1: 1922.19113,
    x2: 630.60782,
    y2: 1922.19113,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 579.30537,
    y1: 1918.69442,
    x2: 626.86037,
    y2: 1918.69442,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 573.37916,
    y1: 1925.32621,
    x2: 633.97306,
    y2: 1925.32621,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 574.30227,
    y1: 1923.89199,
    x2: 633.04957,
    y2: 1923.89199,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 567.38807,
    y1: 1930.73941,
    x2: 638.41204,
    y2: 1930.73941,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 669.69973,
    y1: 1953.00207,
    x2: 581.81842,
    y2: 1953.00207,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 671.66998,
    y1: 1950.72659,
    x2: 580.16523,
    y2: 1950.72659,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 672.14318,
    y1: 1949.99256,
    x2: 579.69613,
    y2: 1949.99256,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 670.70477,
    y1: 1951.99979,
    x2: 581.03188,
    y2: 1951.99979,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 672.6123,
    y1: 1949.19733,
    x2: 579.20012,
    y2: 1949.19733,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 671.19148,
    y1: 1951.39614,
    x2: 580.60942,
    y2: 1951.39614,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 670.20724,
    y1: 1952.5344,
    x2: 581.43504,
    y2: 1952.5344,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    gradientTransform: "translate(502.09713 -775.54405) rotate(-33.87128) scale(.78019 .72217) skewX(21.62018)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49353,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54825,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61091,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67754,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74696,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81851,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89189,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96535,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 572.74878,
    y1: 1925.69965,
    x2: 633.14024,
    y2: 1925.69965,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ab",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ac",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ad",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ae",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "af",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ag",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ah",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ai",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aj",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 664.4908,
    y1: 1938.29454,
    x2: 588.34695,
    y2: 1938.29454,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "al",
    cx: -1305.31934,
    cy: 622.28859,
    fx: -1305.31934,
    fy: 622.28859,
    r: 66.1927,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: -1270.01768,
    y1: 743.41078,
    x2: -1200.98972,
    y2: 743.41078,
    gradientTransform: "translate(403.81447 -1356.23779) rotate(-45.50154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49353,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54825,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61091,
    stopColor: "#ececec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67754,
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74696,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81851,
    stopColor: "#8b8b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89189,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96535,
    stopColor: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 665.75264,
    y1: 1937.78447,
    x2: 589.53517,
    y2: 1937.78447,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 4412.89777,
    y1: -1731.62789,
    x2: 4482.07324,
    y2: -1731.62789,
    gradientTransform: "translate(4471.2417 -1769.21875) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 4510.15876,
    y1: -1724.58279,
    x2: 4433.94129,
    y2: -1724.58279,
    gradientTransform: "translate(4471.2417 -1769.21875) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 4417.15486,
    y1: -1736.86726,
    x2: 4477.54642,
    y2: -1736.86726,
    gradientTransform: "translate(4471.2417 -1769.21875) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ar",
    cx: 2563.75402,
    cy: 4643.7629,
    fx: 2563.75402,
    fy: 4643.7629,
    r: 66.1927,
    gradientTransform: "translate(4755.26204 -775.54405) rotate(-146.12872) scale(.78019 -.72217) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "as",
    cx: 2563.75402,
    cy: 4643.7629,
    fx: 2563.75402,
    fy: 4643.7629,
    r: 66.1927,
    gradientTransform: "translate(4755.26204 -775.54405) rotate(-146.12872) scale(.78019 -.72217) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 4418.58232,
    y1: -1738.03842,
    x2: 4477.59255,
    y2: -1738.03842,
    gradientTransform: "translate(4471.2417 -1769.21875) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "au",
    cx: 2563.75402,
    cy: 4643.7629,
    fx: 2563.75402,
    fy: 4643.7629,
    r: 66.1927,
    gradientTransform: "translate(4755.26204 -775.54405) rotate(-146.12872) scale(.78019 -.72217) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "av",
    cx: 2563.75402,
    cy: 4643.7629,
    fx: 2563.75402,
    fy: 4643.7629,
    r: 66.1927,
    gradientTransform: "translate(4755.26204 -775.54405) rotate(-146.12872) scale(.78019 -.72217) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 4419.85,
    y1: -1739.41261,
    x2: 4476.21403,
    y2: -1739.41261,
    gradientTransform: "translate(4471.2417 -1769.21875) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ax",
    cx: 2563.75402,
    cy: 4643.7629,
    fx: 2563.75402,
    fy: 4643.7629,
    r: 66.1927,
    gradientTransform: "translate(4755.26204 -775.54405) rotate(-146.12872) scale(.78019 -.72217) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ay",
    cx: 2563.75402,
    cy: 4643.7629,
    fx: 2563.75402,
    fy: 4643.7629,
    r: 66.1927,
    gradientTransform: "translate(4755.26204 -775.54405) rotate(-146.12872) scale(.78019 -.72217) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 4425.37373,
    y1: -1745.11955,
    x2: 4468.89637,
    y2: -1745.11955,
    gradientTransform: "translate(4471.2417 -1769.21875) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ba",
    cx: 2563.75402,
    cy: 4643.7629,
    fx: 2563.75402,
    fy: 4643.7629,
    r: 66.1927,
    gradientTransform: "translate(4755.26204 -775.54405) rotate(-146.12872) scale(.78019 -.72217) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bb",
    cx: 2563.75402,
    cy: 4643.7629,
    fx: 2563.75402,
    fy: 4643.7629,
    r: 66.1927,
    gradientTransform: "translate(4755.26204 -775.54405) rotate(-146.12872) scale(.78019 -.72217) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 4508.89689,
    y1: -1724.27238,
    x2: 4432.75308,
    y2: -1724.27238,
    gradientTransform: "translate(4471.2417 -1769.21875) rotate(136) scale(1 -1)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bd",
    cx: 2563.75402,
    cy: 4643.7629,
    fx: 2563.75402,
    fy: 4643.7629,
    r: 66.1927,
    gradientTransform: "translate(4755.26204 -775.54405) rotate(-146.12872) scale(.78019 -.72217) skewX(21.62018)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 2425.71585,
    y1: 4555.66401,
    x2: 2494.73958,
    y2: 4555.66401,
    gradientTransform: "translate(5005.85258 -1356.23779) rotate(-134.49846) scale(1.00004 -1.00004)",
    xlinkHref: "#am"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.96149,28.70603c-.06077.2182-.11701.43622-.16849.65522.05129-.21887.10767-.43725.16849-.65522Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.87435,37.03237c.05457.21216.11252.42334.17578.63459-.06311-.21109-.12127-.42266-.17578-.63459Z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.52146,39.02125c.07004.17859.13167.35789.20808.53556-.07626-.17751-.138-.357-.20808-.53556Z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.53941,30.70387c-.02844.19294-.06493.38478-.08636.57796.02154-.19299.05782-.38521.08636-.57796Z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.60472,26.80737c-.07885.19352-.143.38837-.21454.58272.07145-.19428.13563-.38942.21454-.58272Z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.49335,35.10694c.02529.19275.06474.38429.09717.57666-.03232-.19218-.07193-.38414-.09717-.57666Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.34938,33.2328c-.00023-.01228-.00213-.02447-.0023-.03678.00018.01231.00208.0245.0023.03678Z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.05336,47.07677c.45477.34484.92782.68301,1.43035,1.00872,4.57847,2.96766,10.37934,4.61132,16.31569,4.9409-1.99204-.85441-3.88755-1.85277-5.64781-2.99378-3.88382-2.5174-6.72109-5.47162-8.51186-8.62748.0015.00268.00251.00543.00401.00811-1.71888,1.647-2.87509,3.57148-3.59039,5.66353Z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.87023,69.38848c-.07628-.02011-.15098-.04368-.22713-.06415-.31316-.08421-.62365-.17341-.93382-.26363-.24916-.07237-.49791-.14556-.74536-.22201-.30024-.09277-.5984-.18907-.89564-.28759-.255-.08452-.50858-.17107-.76123-.25984-.28482-.10013-.56826-.20225-.84988-.30774-.26191-.09805-.52146-.19983-.78044-.30253-.26695-.10599-.53332-.21237-.79695-.32326-.2725-.11463-.54118-.23424-.81008-.35423-.24497-.10936-.49035-.21738-.73209-.33106-.28692-.13493-.5687-.27654-.85086-.41763-.21792-.10905-.43774-.21522-.65286-.32804-.32035-.16791-.63398-.34437-.94781-.5207-.16959-.09525-.34281-.18643-.51034-.28414-.47949-.27955-.95137-.56774-1.41316-.86705-14.23354-9.2259-14.43585-24.3173-.44598-33.70749,1.9787-1.32824,4.13602-2.46952,6.4199-3.42719,2.08331-.87436,4.27453-1.59072,6.53285-2.15532,5.56682-1.38969,11.5496-1.84276,17.3898-1.35545l-.07165-5.41352-.08323-6.28114L54.54673.00158c-14.15671-.08761-28.34813,3.46966-39.05543,10.65664-20.91438,14.03784-20.61331,36.60225.6694,50.39721,6.37516,4.1322,13.91177,7.00925,21.90304,8.63356-.40176-.09511-.79852-.2021-1.1961-.30694.00084.00207.00154.00424.00258.00644Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.88609,65.40604c-.16959-.09525-.34276-.18646-.51034-.28414.16753.09771.34076.18889.51034.28414Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.30705,68.29125c-.28487-.10009-.56826-.20225-.84988-.30774.28161.10549.56506.20762.84988.30774Z",
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.96392,68.83869c-.30029-.09274-.5984-.18907-.89564-.28759.29724.09852.5954.19482.89564.28759Z",
    style: {
      fill: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.06971,67.00348c-.24487-.10916-.49055-.21751-.73209-.33106.24174.11368.48712.2217.73209.33106Z",
    style: {
      fill: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6431,69.32433c-.31291-.08411-.62365-.17341-.93382-.26363.31017.09022.62066.17943.93382.26363Z",
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.67673,67.68098c-.26675-.10586-.53327-.2124-.79695-.32326.26363.1109.53.21728.79695.32326Z",
    style: {
      fill: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.48676,66.25479c-.21777-.10889-.43769-.21525-.65286-.32804.21512.11282.43494.21899.65286.32804Z",
    style: {
      fill: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.34938,33.2328c.00794.6257.06181,1.25046.14396,1.87414-.08226-.62361-.13608-1.24866-.14396-1.87414Z",
    style: {
      fill: "url(#s)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.793,29.36125c-.10507.44631-.18705.89379-.25358,1.34262.06639-.44873.14871-.89644.25358-1.34262Z",
    style: {
      fill: "url(#t)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.59052,35.6836c.07611.45111.16888.90064.28383,1.34877-.11489-.44791-.20762-.89773-.28383-1.34877Z",
    style: {
      fill: "url(#u)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.72954,39.5568c.26736.62204.56483,1.23963.9102,1.84833-.34541-.60866-.64279-1.22632-.9102-1.84833Z",
    style: {
      fill: "url(#v)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.39018,27.39009c-.16063.43691-.30586.87495-.42869,1.31595.12289-.44077.26801-.87926.42869-1.31595Z",
    style: {
      fill: "url(#w)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.34708,33.19602c-.00665-.63849.03541-1.27692.10597-1.91418-.07066.63733-.11252,1.27563-.10597,1.91418Z",
    style: {
      fill: "url(#x)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.46936,24.96486c-.33032.60731-.61127,1.22296-.86464,1.84251.25331-.61952.53416-1.23536.86464-1.84251Z",
    style: {
      fill: "url(#y)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.05013,37.66696c.13589.45419.29524.90507.47133,1.35428-.17594-.44906-.33555-.90028-.47133-1.35428Z",
    style: {
      fill: "url(#z)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.05336,47.07677c.7153-2.09205,1.87151-4.01653,3.59039-5.66353-.0015-.00268-.00251-.00543-.00401-.00811-.34536-.6087-.64284-1.22629-.9102-1.84833-.07641-.17767-.13805-.35697-.20808-.53556-.1761-.44922-.33544-.90009-.47133-1.35428-.06327-.21125-.12121-.42243-.17578-.63459-.11495-.44813-.20771-.89766-.28383-1.34877-.03243-.19237-.07187-.38392-.09717-.57666-.08216-.62368-.13603-1.24843-.14396-1.87414-.00023-.01228-.00213-.02447-.0023-.03678-.00656-.63855.03531-1.27685.10597-1.91418.02143-.19319.05793-.38502.08636-.57796.06653-.44883.14852-.8963.25358-1.34262.05149-.219.10773-.43702.16849-.65522.12284-.441.26807-.87903.42869-1.31595.07154-.19435.13569-.3892.21454-.58272.25336-.61955.53431-1.2352.86464-1.84251-2.25833.5646-4.44954,1.28096-6.53285,2.15532-5.35678,6.31005-4.29947,14.33346,3.11685,19.95659Z",
    style: {
      fill: "url(#aa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.05336,47.07677c.7153-2.09205,1.87151-4.01653,3.59039-5.66353-.0015-.00268-.00251-.00543-.00401-.00811-.34536-.6087-.64284-1.22629-.9102-1.84833-.07641-.17767-.13805-.35697-.20808-.53556-.1761-.44922-.33544-.90009-.47133-1.35428-.06327-.21125-.12121-.42243-.17578-.63459-.11495-.44813-.20771-.89766-.28383-1.34877-.03243-.19237-.07187-.38392-.09717-.57666-.08216-.62368-.13603-1.24843-.14396-1.87414-.00023-.01228-.00213-.02447-.0023-.03678-.00656-.63855.03531-1.27685.10597-1.91418.02143-.19319.05793-.38502.08636-.57796.06653-.44883.14852-.8963.25358-1.34262.05149-.219.10773-.43702.16849-.65522.12284-.441.26807-.87903.42869-1.31595.07154-.19435.13569-.3892.21454-.58272.25336-.61955.53431-1.2352.86464-1.84251-2.25833.5646-4.44954,1.28096-6.53285,2.15532-5.35678,6.31005-4.29947,14.33346,3.11685,19.95659Z",
    style: {
      fill: "url(#ab)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87979,67.35772c-.27245-.11466-.54118-.23424-.81008-.35423.26889.12.53758.23961.81008.35423Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87979,67.35772c-.27245-.11466-.54118-.23424-.81008-.35423.26889.12.53758.23961.81008.35423Z",
    style: {
      fill: "url(#ac)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.87023,69.38848c-.00104-.0022-.00174-.00437-.00258-.00644-.0748-.0198-.15009-.03768-.22454-.05771.07614.02047.15084.04404.22713.06415Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.87023,69.38848c-.00104-.0022-.00174-.00437-.00258-.00644-.0748-.0198-.15009-.03768-.22454-.05771.07614.02047.15084.04404.22713.06415Z",
    style: {
      fill: "url(#ad)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.33762,66.67242c-.28707-.13509-.5688-.27648-.85086-.41763.28216.14109.56394.28271.85086.41763Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.33762,66.67242c-.28707-.13509-.5688-.27648-.85086-.41763.28216.14109.56394.28271.85086.41763Z",
    style: {
      fill: "url(#ae)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8339,65.92675c-.32035-.16791-.63403-.34434-.94781-.5207.31383.17633.62746.3528.94781.5207Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8339,65.92675c-.32035-.16791-.63403-.34434-.94781-.5207.31383.17633.62746.3528.94781.5207Z",
    style: {
      fill: "url(#af)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.37575,65.12191c-.47944-.27959-.95137-.56774-1.41316-.86705.46179.29931.93367.5875,1.41316.86705Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.37575,65.12191c-.47944-.27959-.95137-.56774-1.41316-.86705.46179.29931.93367.5875,1.41316.86705Z",
    style: {
      fill: "url(#ag)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.06828,68.55109c-.25495-.08455-.50863-.17104-.76123-.25984.25265.08877.50623.17532.76123.25984Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.06828,68.55109c-.25495-.08455-.50863-.17104-.76123-.25984.25265.08877.50623.17532.76123.25984Z",
    style: {
      fill: "url(#ah)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.70928,69.0607c-.24912-.0724-.49796-.14553-.74536-.22201.24745.07645.49619.14964.74536.22201Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.70928,69.0607c-.24912-.0724-.49796-.14553-.74536-.22201.24745.07645.49619.14964.74536.22201Z",
    style: {
      fill: "url(#ai)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.45717,67.98351c-.26181-.09812-.52156-.19977-.78044-.30253.25898.1027.51853.20448.78044.30253Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.45717,67.98351c-.26181-.09812-.52156-.19977-.78044-.30253.25898.1027.51853.20448.78044.30253Z",
    style: {
      fill: "url(#aj)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.93651,27.12018c-2.28388.95766-4.44119,2.09895-6.4199,3.42719-13.98987,9.39019-13.78757,24.4816.44598,33.70749.46179.29931.93372.58746,1.41316.86705.16758.09768.34076.18889.51034.28414.31378.17637.62746.3528.94781.5207.21517.11279.43509.21915.65286.32804.28206.14116.56379.28255.85086.41763.24154.11355.48722.2219.73209.33106.26889.12.53763.23957.81008.35423.26368.11086.5302.21741.79695.32326.25888.10276.51862.20441.78044.30253.28161.10549.56501.20765.84988.30774.2526.0888.50628.17529.76123.25984.29724.09852.59535.19486.89564.28759.2474.07648.49624.14961.74536.22201.31017.09022.6209.17952.93382.26363.07446.02003.14975.03791.22454.05771-2.70027-6.478-5.20266-15.31465-2.81529-22.30247.00027-.00098.00074-.00183.00101-.00281-7.41632-5.62312-8.47362-13.64654-3.11685-19.95659Z",
    style: {
      fill: "url(#ak)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.93651,27.12018c-2.28388.95766-4.44119,2.09895-6.4199,3.42719-13.98987,9.39019-13.78757,24.4816.44598,33.70749.46179.29931.93372.58746,1.41316.86705.16758.09768.34076.18889.51034.28414.31378.17637.62746.3528.94781.5207.21517.11279.43509.21915.65286.32804.28206.14116.56379.28255.85086.41763.24154.11355.48722.2219.73209.33106.26889.12.53763.23957.81008.35423.26368.11086.5302.21741.79695.32326.25888.10276.51862.20441.78044.30253.28161.10549.56501.20765.84988.30774.2526.0888.50628.17529.76123.25984.29724.09852.59535.19486.89564.28759.2474.07648.49624.14961.74536.22201.31017.09022.6209.17952.93382.26363.07446.02003.14975.03791.22454.05771-2.70027-6.478-5.20266-15.31465-2.81529-22.30247.00027-.00098.00074-.00183.00101-.00281-7.41632-5.62312-8.47362-13.64654-3.11685-19.95659Z",
    style: {
      fill: "url(#al)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.81046,70.63216c.1193.01506.24025.02212.35983.03673-.11898-.01448-.23792-.029-.35687-.04404-.00107.00232-.00209.00486-.00296.00731Z",
    style: {
      fill: "url(#am)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.05233,47.07955c.00028-.00096.00084-.00179.00111-.0028.45463.34485.92765.68303,1.4302,1.00872,4.57864,2.96768,10.37939,4.61134,16.3158,4.94093-.20642-.01135-.41285-.0283-.61899-.04295-2.45034,5.76655-5.15585,12.28025-7.36717,17.64141-1.93497-.2442-3.85546-.55-5.74949-.93586-.4017-.09513-.79867-.20212-1.1962-.30695-2.70022-6.47801-5.20265-15.31468-2.81527-22.30249Z",
    style: {
      fill: "url(#an)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.94652,82.9955c-.45463.34485-.92765.68303-1.4302,1.00872-4.57836,2.96768-9.76012,4.56838-15.69653,4.89798,1.99208-.85442,3.26851-1.80981,5.02854-2.95082,3.88388-2.51741,6.72115-5.47163,8.51183-8.62752-.00139.00271-.00251.00547-.0039.00813,1.7188,1.64701,2.87516,3.57147,3.59026,5.66351Z",
    style: {
      fill: "url(#ao)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12986,105.30722c.07633-.02012.15099-.04369.22704-.06413.31312-.0842.62373-.17341.93378-.26363.24932-.0724.49781-.14557.74546-.22201.30002-.09279.59838-.18907.89562-.28761.2549-.08452.50868-.17107.76106-.25986.28498-.1001.56829-.20221.84993-.30773.26214-.09803.52149-.19982.78056-.30254.26687-.10598.53319-.21236.797-.32326.27245-.11461.54099-.23423.81009-.35422.24487-.10937.49029-.21737.73209-.33106.28693-.13496.56857-.27654.85076-.41765.21784-.10905.43764-.21521.65298-.32803.32036-.1679.63376-.34439.94771-.52069.16937-.09527.34265-.18646.51035-.28416.47943-.27952.95133-.56773,1.41293-.86705,14.23374-9.22589,14.43598-24.31727.44628-33.70747-1.97899-1.32825-4.13627-2.46955-6.42002-3.42718-2.08318-.87436-4.27444-1.59074-6.53284-2.15534-5.56674-1.38967-11.54968-1.84274-17.38998-1.35545l.07187-5.41352.08302-6.28113.15767-11.91317c14.15657-.0876,28.34824,3.46968,39.05551,10.65662,20.91422,14.03787,20.61336,36.60225-.66941,50.39721-6.37517,4.13222-13.91171,7.00927-21.90316,8.63358.40198-.09513.79867-.20212,1.1962-.30695-.00084.00207-.00167.00423-.00251.00643Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51633,84.00422c.50255-.32569.97557-.66387,1.4302-1.00872.00028.00101.00084.00184.00111.0028,2.38738,6.98786-.11505,15.82448-2.81527,22.30249-.39753.10483-.79421.21181-1.1962.30695-1.89402.38591-3.81451.69167-5.74949.93586-2.21132-5.36116-4.91683-11.87486-7.36689-17.64141",
    style: {
      fill: "url(#ap)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.94652,82.9955c-.7151-2.09204-1.87146-4.0165-3.59026-5.66351.00139-.00266.00251-.00542.0039-.00813.34543-.60866.64295-1.22627.91038-1.8483.07633-.17768.13789-.35697.20809-.53557.17606-.44921.3354-.90008.47135-1.35425.06324-.21126.12118-.42243.1755-.63461.11505-.44811.20782-.89765.28415-1.34879.03231-.19234.07187-.38389.09694-.57664.08246-.62363.13622-1.24865.14402-1.87412.00028-.01231.00223-.02448.00223-.0368.00669-.63852-.03538-1.27694-.10586-1.91417-.02145-.19321-.05794-.38504-.08636-.57797-.06658-.44885-.14848-.89631-.25378-1.34263-.05126-.21898-.10753-.43699-.16826-.65519-.12285-.44104-.26799-.87904-.42873-1.31599-.07159-.19431-.13567-.38917-.2145-.5827-.25322-.6195-.5343-1.23537-.86469-1.84251,2.2584.56461,4.44966,1.28099,6.53284,2.15534,5.3567,6.31002,4.29951,14.33347-3.11696,19.95656Z",
    style: {
      fill: "url(#aq)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.94652,82.9955c-.7151-2.09204-1.87146-4.0165-3.59026-5.66351.00139-.00266.00251-.00542.0039-.00813.34543-.60866.64295-1.22627.91038-1.8483.07633-.17768.13789-.35697.20809-.53557.17606-.44921.3354-.90008.47135-1.35425.06324-.21126.12118-.42243.1755-.63461.11505-.44811.20782-.89765.28415-1.34879.03231-.19234.07187-.38389.09694-.57664.08246-.62363.13622-1.24865.14402-1.87412.00028-.01231.00223-.02448.00223-.0368.00669-.63852-.03538-1.27694-.10586-1.91417-.02145-.19321-.05794-.38504-.08636-.57797-.06658-.44885-.14848-.89631-.25378-1.34263-.05126-.21898-.10753-.43699-.16826-.65519-.12285-.44104-.26799-.87904-.42873-1.31599-.07159-.19431-.13567-.38917-.2145-.5827-.25322-.6195-.5343-1.23537-.86469-1.84251,2.2584.56461,4.44966,1.28099,6.53284,2.15534,5.3567,6.31002,4.29951,14.33347-3.11696,19.95656Z",
    style: {
      fill: "url(#ar)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6506,69.15157c-.0078.62547-.06156,1.25048-.14402,1.87412.08218-.62368.13594-1.24842.14402-1.87412Z",
    style: {
      fill: "url(#as)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6506,69.15157c-.0078.62547-.06156,1.25048-.14402,1.87412.08218-.62368.13594-1.24842.14402-1.87412Z",
    style: {
      fill: "url(#at)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6506,69.15157c-.0078.62547-.06156,1.25048-.14402,1.87412.08218-.62368.13594-1.24842.14402-1.87412Z",
    style: {
      fill: "url(#au)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.54697,67.2006c.07048.63723.11254,1.27566.10586,1.91417.00669-.63856-.03538-1.27685-.10586-1.91417Z",
    style: {
      fill: "url(#av)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.54697,67.2006c.07048.63723.11254,1.27566.10586,1.91417.00669-.63856-.03538-1.27685-.10586-1.91417Z",
    style: {
      fill: "url(#aw)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.54697,67.2006c.07048.63723.11254,1.27566.10586,1.91417.00669-.63856-.03538-1.27685-.10586-1.91417Z",
    style: {
      fill: "url(#ax)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.53065,60.88359c.33039.60714.61147,1.22301.86469,1.84251-.2535-.61955-.5343-1.23519-.86469-1.84251Z",
    style: {
      fill: "url(#ay)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.53065,60.88359c.33039.60714.61147,1.22301.86469,1.84251-.2535-.61955-.5343-1.23519-.86469-1.84251Z",
    style: {
      fill: "url(#az)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.53065,60.88359c.33039.60714.61147,1.22301.86469,1.84251-.2535-.61955-.5343-1.23519-.86469-1.84251Z",
    style: {
      fill: "url(#ba)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12986,105.30722c.00084-.0022.00167-.00436.00251-.00643.07494-.0198.15015-.03767.22453-.0577-.07605.02044-.15071.04401-.22704.06413Z",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12986,105.30722c.00084-.0022.00167-.00436.00251-.00643.07494-.0198.15015-.03767.22453-.0577-.07605.02044-.15071.04401-.22704.06413Z",
    style: {
      fill: "url(#bb)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06349,63.03893c2.28375.95764,4.44103,2.09893,6.42002,3.42718,13.98971,9.3902,13.78746,24.48158-.44628,33.70747-.4616.29932-.9335.58753-1.41293.86705-.1677.09771-.34097.18889-.51035.28416-.31395.1763-.62735.35279-.94771.52069-.21534.11282-.43513.21898-.65298.32803-.2822.14112-.56383.28269-.85076.41765-.2418.11369-.48723.22169-.73209.33106-.2691.11999-.53765.2396-.81009.35422-.26381.11089-.53013.21728-.797.32326-.25907.10271-.51843.20451-.78056.30254-.28164.10552-.56495.20763-.84993.30773-.25239.0888-.50617.17534-.76106.25986-.29724.09853-.59559.19482-.89562.28761-.24765.07644-.49614.14962-.74546.22201-.31005.09022-.62066.17943-.93378.26363-.07438.02003-.14959.0379-.22453.0577,2.70022-6.47801,5.20265-15.31463,2.81527-22.30249-.00028-.00096-.00084-.00179-.00111-.0028,7.41647-5.62309,8.47366-13.64654,3.11696-19.95656Z",
    style: {
      fill: "url(#bc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06349,63.03893c2.28375.95764,4.44103,2.09893,6.42002,3.42718,13.98971,9.3902,13.78746,24.48158-.44628,33.70747-.4616.29932-.9335.58753-1.41293.86705-.1677.09771-.34097.18889-.51035.28416-.31395.1763-.62735.35279-.94771.52069-.21534.11282-.43513.21898-.65298.32803-.2822.14112-.56383.28269-.85076.41765-.2418.11369-.48723.22169-.73209.33106-.2691.11999-.53765.2396-.81009.35422-.26381.11089-.53013.21728-.797.32326-.25907.10271-.51843.20451-.78056.30254-.28164.10552-.56495.20763-.84993.30773-.25239.0888-.50617.17534-.76106.25986-.29724.09853-.59559.19482-.89562.28761-.24765.07644-.49614.14962-.74546.22201-.31005.09022-.62066.17943-.93378.26363-.07438.02003-.14959.0379-.22453.0577,2.70022-6.47801,5.20265-15.31463,2.81527-22.30249-.00028-.00096-.00084-.00179-.00111-.0028,7.41647-5.62309,8.47366-13.64654,3.11696-19.95656Z",
    style: {
      fill: "url(#bd)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.18947,106.55091c-.11923.01507-.24013.0221-.35992.0367.11923-.01447.2379-.02899.35713-.04401.00111.0023.00195.00487.00279.0073Z",
    style: {
      fill: "url(#be)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpcSlogo);
export default __webpack_public_path__ + "static/media/BPC_slogo.45b00897e889a516f94f340a789df352.svg";
export { ForwardRef as ReactComponent };